export const ECCN_MATRIX_COLUMN_WIDTHS = {
  XS: ['50%', '50%', '200px', '200px', '200px', '200px', '200px'],
  SM: ['33.33%', '33.33%', '33.33%', '180px', '180px', '180px', '180px'],
  MD: ['25%', '25%', '25%', '25%', '120px', '180px', '180px'],
  LG: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
};

export const ECCN_MATRIX_MAX_COLUMNS = 7;
export const ROWS_PER_PAGE = 6;
export const COLUMN_LINK = 7;
export const MATRIX_SEARCH_COLUMN_START = 0;
export const MATRIX_SEARCH_COLUMN_END = 3;
export const ACCORDION_HEADLINE_LEVEL = 'H3';
